import { useState, useEffect } from "react";
import { core } from "../../lib/api";

export function useRecordingUrl(fileKey?: string | null, callId?: string | null) {
  const [signedUrl, setSignedUrl] = useState<string | null>(null);

  useEffect(() => {
    if (!fileKey) {
      setSignedUrl(null);
      return;
    }

    if (fileKey.startsWith("http")) {
      setSignedUrl(fileKey);
      return;
    }

    core<{ url: string }>("/api/v1/recording-url", {
      method: "POST",
      // Orgs with invitations or agent scope live refuse to sign a key without its call.
      body: JSON.stringify(callId ? { file_key: fileKey, call_id: callId } : { file_key: fileKey }),
    })
      .then((res) => setSignedUrl(res.url))
      .catch((e) => console.error("Failed to fetch recording url:", e));
  }, [fileKey, callId]);

  return signedUrl;
}
